import { render, staticRenderFns } from "./AssetForm.vue?vue&type=template&id=ffa0d1e8&"
import script from "./AssetForm.vue?vue&type=script&lang=js&"
export * from "./AssetForm.vue?vue&type=script&lang=js&"
import style0 from "./AssetForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports